import validator from 'validator';

const validateLogin = (data) => {
  let errors = {}

  const {email, password} = data;

  if(validator.isEmpty(email)) {
    errors.email = '이메일 ID를 입력해주세요.'
  }
  if(validator.isEmpty(password)) {
    errors.password = '비밀번호를 입력해주세요.'
  }

  return {
    isInvalid: Object.keys(errors).length > 0,
    error: errors
  }
}

export default validateLogin;